import Api from '@/services/api'

export default {
    async getAlertas () {
        const response = await new Api().get('Alertas')

        return response.dados
    },
}